export default __webpack_public_path__ + "static/media/157.d7ee3bdc.jpg";